import { createSlice } from '@reduxjs/toolkit';

import { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';
import type { ContentOfType } from 'commonTypes/api/scenarios/scenario';

import { setScenario } from 'entities/scenario';

export interface TimerState {
  remaining: number;
}

const initialState: TimerState = {
  remaining: 0,
};

export const creditTimerSlice = createSlice({
  name: 'creditTimer',
  initialState,
  reducers: {
    tick(state) {
      state.remaining = Math.max(state.remaining - 1, 0);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setScenario, (state, { payload }) => {
      if (payload.step === SCENARIO_STEP.CREDIT_SELECTION) {
        const content = payload.content as ContentOfType<SCENARIO_STEP.CREDIT_SELECTION>;

        state.remaining = content.timerRemainingSeconds;
      }
    });
  },
});

export const { tick } = creditTimerSlice.actions;
